<template>
  <div>
    <!-- {{ fieldType }} -->
    <!-- {{ filter }} -->
    <!-- <pre class="language-json"><code>{{ filter  }}</code></pre> -->
    <div class="filter">
      <!-- compo tipo lógico -->
      <b-form-select
        v-if="fieldType == '1'"
        v-model="filter.value"
        id="perPageSelect"
        class="filters"
        :options="optionsActive"
        debounce="3000"
      ></b-form-select>

      <!-- compo tipo data -->
      <base-filter-date-workflow
        v-else-if="fieldType == '2'"
        ref="baseFilterDate"
        :dateFill.sync="filter.value"
        :dateBegin.sync="filter.value"
        :dateEnd.sync="filter.value"
        :filterName.sync="filter.label"
        :optionFilterDate.sync="getOptionFilterDate"
        :filterDate="filterDate"
        @saveFilter="saveFilterDate"
      >
      </base-filter-date-workflow>

      <!-- compo tipo Hora -->
      <b-form-input
        v-else-if="fieldType == '3'"
        type="time"
        :id="labelName"
        v-model="filter.value"
        class="filters"
        debounce="3000"
      />

      <!-- compo tipo decimal -->
      <b-form-input
        v-else-if="fieldType == '4'"
        :id="labelName"
        type="text"
        :placeholder="labelName"
        v-mask="'money'"
        v-model="filter.value"
        class="filters"
        debounce="3000"
      />

      <!-- compo tipo int -->
      <b-form-input
        v-else-if="fieldType == '5'"
        :id="labelName"
        type="number"
        :placeholder="labelName"
        v-model="filter.value"
        class="filters"
        debounce="3000"
      />

      <!-- compo tipo List/Objetivo -->
      <!-- <b-form-select v-else-if="fieldType == '7' || fieldType == '13'" v-model="filter.value" id="perPageSelect"
        class="filters" :options="options"></b-form-select> -->
      <single-select
        v-else-if="fieldType == '7' || fieldType == '13'"
        :value.sync="filter.value"
        :value-property="'value'"
        :options="options"
        debounce="3000"
      />
      <!-- Responsável -->
      <!-- <b-form-select v-else-if="fieldType == '14'" v-model="filter.value" id="perPageSelect" class="filters"
        :options="options"></b-form-select> -->

      <single-select
        v-else-if="fieldType == '14'"
        :value.sync="filter.value"
        :value-property="'value'"
        :options="options"
        debounce="3000"
      >
      </single-select>

      <!-- Veículos -->
      <single-select
        v-else-if="fieldType == '20'"
        :value.sync="filter.value"
        :value-property="'value'"
        :options="options"
        debounce="3000"
      >
      </single-select>

      <!-- compo tipo CNPJ -->
      <b-form-input
        v-else-if="fieldType == '15' || fieldType == '16'"
        v-model="filter.value"
        :placeholder="'Buscar por ' + labelName"
        v-mask="'99.999.999/9999-99'"
        class="filters"
        debounce="3000"
      />

      <!-- compo tipo CPF -->
      <b-form-input
        v-else-if="fieldType == '17'"
        v-model="filter.value"
        :placeholder="'Buscar por ' + labelName"
        v-mask="'999.999.999-99'"
        class="filters"
        debounce="3000"
      />

      <!-- campo trip plan -->
      <multiselect
        v-else-if="fieldType == '19'"
        v-model="selectOpt.value"
        label="text"
        track-by="value"
        :close-on-select="true"
        placeholder="plano de viagem"
        :showLabels="false"
        :multiple="false"
        :options="optionsTripPlan"
        @input="onChangeFieldValue"
        debounce="3000"
      />

      <!-- compo tipo texto -->
      <b-form-input
        v-else
        v-model="filter.value"
        :placeholder="'Buscar por ' + labelName"
        debounce="3000"
        class="filters"
      />
      <!-- {{ filter.label }} -->
    </div>
    <!-- {{ filterDate.optionFilterDate }} -->
    <!-- {{ dateOpt }} -->
    <!-- <div>labelName: {{ labelName }}</div> -->
    <!-- <pre class="language-json"><code>FiltersApplied: {{ filterDateApplied }}</code></pre> -->
    <!-- <pre class="language-json"><code>FiltersApplied: {{ filterDateApplied }}</code></pre> -->
    <!-- <div>{{ filterDate }}</div> -->
  </div>
</template>
<script>
import AwesomeMask from "awesome-mask";
export default {
  name: "WorkflowFilter",
  directives: {
    mask: AwesomeMask,
  },
  components: {
    BaseFilterDateWorkflow: () =>
      import("@/components_rms/base/BaseFilterDateWorkflow.vue"),
    SingleSelect: () => import("@/components_rms/base/SingleSelect.vue"),
  },
  props: {
    labelName: String,
    fieldType: String,
    fieldId: String,
    filter: Object,
    dateOpt: Number,
    filterApplied: Object,
  },
  data() {
    return {
      selectOpt: {
        label: "",
        value: [],
      },
      optionsActive: [
        { value: "", text: "Todos" },
        { value: "1", text: "Sim" },
        { value: "0", text: "Não" },
      ],
      options: [],
      optionsTripPlan: [],
      optionFilterDate: 0,
      filterDateApplied: [],
      filterDate: {
        id: 0,
        urlPage: "",
        optionFilterDate: 0,
        fieldName: "",
      },
    };
  },
  created() {
    switch (this.fieldType) {
      case "2":
        this.filterDate.optionFilterDate = this.dateOpt;
        this.filterDate.urlPage = this.filterApplied.pageUrl;
        this.filterDate.fieldName = this.labelName;
        this.getFilterDate();
        break;
      case "7":
        this.getList();
        break;
      case "13":
        this.getList();
        break;
      case "14":
        this.getListUsers();
        break;
      case "19":
        this.getTripPlan();
        break;
      case "20":
        this.getListVehicles();
        break;
    }
  },
  computed: {
    getOptionFilterDate: {
      get: function () {
        // return this.filterDate.optionFilterDate;
        return this.dateOpt; //  this.filterDate.optionFilterDate;
      },
      set: function (value) {
        // this.filterDate.optionFilterDate = this.dateOpt;
        // this.saveFilterDate();
        // this.filterDate.optionFilterDate = value;
        this.$emit("update:dateOpt", parseInt(value));
        // this.$emit("forceUpdate");
        // this.$emit("changeDateOption", value);
        // this.dateOpt = value;
        // this.$emit("forceUpdate");
        // this.$emit("update:dateBegin", value);
        // this.$emit("update:dateEnd", `${value}T23:59:59`);
      },
    },
  },
  methods: {
    getList() {
      this.$apiWorkflow
        .get("/customFilter/GetAllOptions/" + this.fieldId)
        .then((response) => {
          this.options = response.data;
        });
    },
    getListUsers() {
      this.$apiWorkflow
        .get("/customFilter/GetAllOptions/" + this.fieldId)
        .then((response) => {
          this.options = [];
          let ddUsers = response.data;
          ddUsers.forEach((ddUser) => {
            this.options.push({ value: ddUser.text, text: ddUser.text });
          });
        });
    },
    getListVehicles() {
      this.options = [];
      this.$apiWorkflow
        .get(`/v2/field/vehicles?fieldId=${this.fieldId}&justAvailable=false`)
        .then((response) => {
          this.options = response.data;
        });
    },
    getTripPlan() {
      this.$apiWorkflow.get("/tripPlan/dropdown/").then((response) => {
        this.optionsTripPlan = response.data;
      });
    },
    onChangeFieldValue(value) {
      if (value) this.filter.value = value.value;
      else this.filter.value = "";
    },
    getFilterDate() {
      // console.log("filterDate");
      // console.log(this.filterDate);
      this.$apiWorkflow
        .post("/fitlerApplied/GetFilterDate/", this.filterDate)
        .then((response) => {
          // console.log(response);
          this.filterDate = response.data;
          this.$emit("update:dateOpt", this.response.optionFilterDate);
          this.$forceUpdate();
        });
      // this.$forceUpdate();
    },
    saveFilterDate() {
      // console.log(this.filterDate);
      this.$apiWorkflow
        .post("/fitlerApplied/SaveFilterDate/", this.filterDate)
        .then((response) => {
          // console.log(response)
          this.$emit("update:dateOpt", this.filterDate.optionFilterDate);
          this.$forceUpdate();
          this.filterDate = response.data;
        });
      this.$forceUpdate();
    },
  },
  watch: {
    optionFilterDate() {
      this.$emit("update:dateOpt", this.optionFilterDate);
      this.$forceUpdate();
      // this.saveFilterDate();
    },
    dateOpt() {
      this.filterDate.optionFilterDate = this.dateOpt;
      this.saveFilterDate();
    },
  },
};
</script>
<style scoped>
.filters {
  min-width: 80px;
}
</style>